// Suggestions (ISQ — initial suggested questions) domain slice.
//
// Both fields originate inside useMessageHistory (`isSuggestedQuestionsLoading`
// from a GraphQL hook, `wereQuestionsGenerated` from a ref), which *publishes* them
// into this slice directly (WS-10.1 — no provider effect-bridge). The sole consumer
// (SuggestedQuestions) reads them via a selector.
export const suggestionsSlice = (set) => ({
  isSuggestedQuestionsLoading: false,
  wereQuestionsGenerated: false,
  setIsSuggestedQuestionsLoading: (value) => set({ isSuggestedQuestionsLoading: value }),
  setWereQuestionsGenerated: (value) => set({ wereQuestionsGenerated: value }),
});
